import React, { useEffect, useState } from "react"
import { setIngredients, useAppDispatch } from "src/store"
import RecipeBuilder from "../../components/RecipeBuilder"
import Flexbox from '../../foundation'
import useApi from '../../hooks/useApi'
import { Ingredient } from "src/types/types"

const DemoView = () => {

    const api = useApi()
    const [loaded, setLoaded] = useState(false)
    const dispatch = useAppDispatch()

    useEffect(() => {
        if (api && !loaded) {
            fetchKitchen()
        } else if (api) {
            setLoaded(true)
        }
    }, [api, loaded])

    const fetchKitchen = async () => {
        if (api) {
            let ingredients: Ingredient[] = await api.fetchIngredients()
            dispatch(setIngredients(ingredients))
            setLoaded(true)
        }
    }

    return (
        <Flexbox>
            <RecipeBuilder />
        </Flexbox>
    )
}

export default DemoView